export class LodeStarFeeTypeApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTypes({ feeTypeId }) {
    return this.#http.get(`/lodeStarFeeType/${feeTypeId}`);
  }

  async createType({ feeTypeId, ...body }) {
    return this.#http.post(`/lodeStarFeeType/${feeTypeId}`, body);
  }

  async editType({ lodeStarFeeTypeId, ...body }) {
    return this.#http.put(`/lodeStarFeeType/${lodeStarFeeTypeId}`, body);
  }

  async deleteType({ lodeStarFeeTypeId }) {
    return this.#http.delete(`/lodeStarFeeType/${lodeStarFeeTypeId}`);
  }
}
